import { Category } from "@forcode/domain";
import { Link } from "../../../atom";
import { BASE_CLASS } from "../PostCard";
import css from "../PostCard.module.css";

interface PostCardMetaProps {
  category: Category;
  createdAt: number;
}

export const PostCardMeta = ({ category, createdAt }: PostCardMetaProps) => {
  const formatDate = new Intl.DateTimeFormat("es-ES", {
    year: "numeric",
    month: "short",
    day: "2-digit",
  }).format(createdAt);

  return (
    <div className={css[`${BASE_CLASS}-meta`]}>
      <Link href={`/blog/${category.slug}`} className={css["category"]}>
        {category.name}
      </Link>
      {category && " — "}
      {formatDate}
    </div>
  );
};
